module.exports = __webpack_public_path__ + "img/iconX.e875d20c.png";